export default __webpack_public_path__ + "static/media/nila_narayan.79a3aded.jpg";